import { useGateValue } from "@statsig/react-bindings";

export const useEnableLineAdsIntegration = (): boolean =>
  useGateValue("enable_frontend_line_ads_integration");
